import React from 'react';

const IconLinkedin = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z" transform="translate(-2 -2)" />
      <path fill={color} d="M19.04 19.043h-2.962v-4.64c0-1.107-.023-2.531-1.544-2.531-1.544 0-1.78 1.204-1.78 2.449v4.722H9.793V9.5h2.845v1.3h.038c.397-.75 1.364-1.54 2.808-1.54 3.001 0 3.556 1.974 3.556 4.545v5.238zM6.447 8.194c-.954 0-1.72-.772-1.72-1.72 0-.949.767-1.72 1.72-1.72.95 0 1.72.771 1.72 1.72s-.771 1.72-1.72 1.72zm1.484 10.85h-2.97V9.5h2.97v9.543zM20.521 2H3.476C2.66 2 2 2.645 2 3.44v17.12c0 .796.66 1.44 1.476 1.44h17.042c.815 0 1.482-.644 1.482-1.44V3.44C22 2.646 21.333 2 20.518 2h.003z" transform="translate(-2 -2)" />
    </g>
  </svg>
);

export default IconLinkedin;
